import { render, staticRenderFns } from "./coupon_send.vue?vue&type=template&id=53399864&"
import script from "./coupon_send.vue?vue&type=script&lang=js&"
export * from "./coupon_send.vue?vue&type=script&lang=js&"
import style0 from "./coupon_send.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports